/**
 * Production hard-locks.
 *
 * The platform runs with real money only. Sandbox / simulated environments are
 * disabled at the application level so no admin action can put live users back
 * on fake balances. Flip these to `true` (and re-enable the `demo_trading`
 * module) if a test environment is ever needed again.
 */

/** When false, the platform is pinned to live mode and the environment switch is hidden. */
export const SANDBOX_MODE_ENABLED = false;
